<div class="row sub-section-title">
    <div class="col-12">
        <img src="/assets/images/icons/funded_icon_rocket.svg" />
        <span>Congratulations, this application has funded!</span>
    </div>
</div>